// Import model
import { StartObjectAppointmentSendOmwsmsRequest } from '../models/StartObjectAppointmentSendOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentSendOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentSendOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentSendOmwsmsRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentSendOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentSendOmwsmsRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentSendOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentSendOmwsmsRequest');
    }


    const instance: StartObjectAppointmentSendOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentSendOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentSendOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentSendOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentSendOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentSendOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentSendOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentSendOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentSendOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
